/** Shared public contact + social links for outreach (website, DMs, calls). */
export const PUBLIC_PHONE_PRIMARY = '01622809469';
export const PUBLIC_PHONE_MOBILE = '447807350970';
export const PUBLIC_EMAIL = 'info@osabeacares.co.uk';

export const SOCIAL_LINKS = {
  whatsapp: `https://wa.me/${PUBLIC_PHONE_MOBILE}`,
  instagram: 'https://www.instagram.com/osabeacaresolutions',
  linkedin: 'https://www.linkedin.com/company/osabea-healthcare-solutions',
};

export const STAFFING_ROLE_OPTIONS = [
  'Healthcare Assistant',
  'Nurse',
];
